import React from "react";
import { useSelector } from "react-redux";
import { Typography, Grid } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import { IMAGES_ENDPOINT } from "@icarius-connection/endpoints";
import { ImagePlaceholder } from "@icarius-icons/index";
import { getAppColor } from "@icarius-app/selectors";

const GalleryButtonAndDisplay = (props) => {
    const { required, disabled, image, handleOpenGallery } = props;

    const color = useSelector(getAppColor);

    return (
        <>
            {!disabled && (
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }} onClick={handleOpenGallery}>
                    <Typography
                        variant="h6"
                        className="whiteText"
                        style={{ cursor: "pointer", fontWeight: 400, fontSize: 16, textDecoration: "underline" }}
                    >
                        {getLocalizedString("groupImagesTitle")}
                    </Typography>
                    {required && (
                        <Typography
                            style={{ fontWeight: 400, fontSize: 16, marginLeft: 5 }}
                            className="errorColor"
                            variant="caption"
                        >
                            {"*"}
                        </Typography>
                    )}
                </div>
            )}
            <Grid
                container
                item
                xs={12}
                style={{
                    marginTop: 10,
                    width: 220,
                    height: 140,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {image ? (
                    <img
                        style={{ maxWidth: 220, maxHeight: 140 }}
                        src={IMAGES_ENDPOINT + image}
                        alt={"imageNotFound"}
                    />
                ) : (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: 220,
                            height: 140,
                            backgroundColor: color,
                        }}
                    >
                        <ImagePlaceholder fontSize="small" style={{ fill: "var(--mainText)" }} />
                    </div>
                )}
            </Grid>
        </>
    );
};

export default GalleryButtonAndDisplay;
